import { useSettingsStore } from '../stores/appStore';

export function LoadingScreen() {
  const { language } = useSettingsStore();
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-accent-50 dark:from-gray-900 dark:to-gray-800">
      <div className="text-center">
        {/* Logo/Brand */}
        <div className="w-16 h-16 mx-auto mb-6 relative">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl animate-pulse-subtle" />
          <div className="absolute inset-1 bg-white dark:bg-gray-900 rounded-xl flex items-center justify-center">
            <svg
              className="w-8 h-8 text-primary-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
        </div>
        
        {/* Spinner */}
        <div className="w-8 h-8 mx-auto mb-4 border-3 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
        
        {/* Loading text */}
        <p className="text-gray-600 dark:text-gray-400">
          {language === 'ar' ? 'جاري التحميل...' : 'Loading...'}
        </p>
      </div>
    </div>
  );
}
